import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material'
import { Button } from 'components'
import Box from '@mui/material/Box'

const AlertModal = ({ open, message, onClose, title = 'Alert' }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <Box sx={{ whiteSpace: 'pre-line', color: 'error.main' }}>{message}</Box>
    </DialogContent>
    <DialogActions>
      <Button text="OK" onClick={onClose} />
    </DialogActions>
  </Dialog>
)

export default AlertModal
